import { Box } from '@mui/material';
import IconDisabledFlag from '../../assets/icons/IconDisabledFlag';
import IconFilledFlag from '../../assets/icons/IconFilledFlag';
import CustomTooltip from '../../ui/atoms/CustomTooltip';
import IconEmptyFlag from '../../assets/icons/IconEmptyFlag';

interface FlagIconProps {
  isDecisionTaken: boolean;
  medallions: string[] | any;
}

const FlagIcon = ({ isDecisionTaken, medallions }: FlagIconProps) => {
  const MadalionsData =
    medallions?.length === 1
      ? medallions[0]
      : medallions?.map((data: string | any) => data).join(', ');
  if (isDecisionTaken) {
    return <IconDisabledFlag />;
  }

  if (medallions === '') {
    return <IconFilledFlag />;
  }

  if (medallions === undefined) {
    return null;
  }

  if (medallions?.length === 0) {
    return <IconEmptyFlag />;
  }

  return (
    <CustomTooltip label={MadalionsData} arrow placement='top'>
      <Box sx={{ px: '0.1rem', cursor: 'pointer' }}>
        <IconFilledFlag />
      </Box>
    </CustomTooltip>
  );
};

export default FlagIcon;
